import { CreateOperatorRequest } from '@/types/apis/operators/CreateOperatorRequest'
import { CreateOperatorResponse } from '@/types/apis/operators/CreateOperatorResponse'
import { DeleteOperatorRequest } from '@/types/apis/operators/DeleteOperatorRequest'
import { DeleteOperatorResponse } from '@/types/apis/operators/DeleteOperatorResponse'
import { GetAllOperatorsRequest } from '@/types/apis/operators/GetAllOperatorsRequest'
import { GetAllOperatorsResponse } from '@/types/apis/operators/GetAllOperatorsResponse'
import { GetOperatorRequest } from '@/types/apis/operators/GetOperatorRequest'
import { GetOperatorResponse } from '@/types/apis/operators/GetOperatorResponse'
import { UpdateOperatorRequest } from '@/types/apis/operators/UpdateOperatorRequest'
import { UpdateOperatorResponse } from '@/types/apis/operators/UpdateOperatorResponse'

import axios from './axios'

const API_ENDPOINT = '/customer'

export const getAllOperators = (request?: GetAllOperatorsRequest): Promise<GetAllOperatorsResponse> => {
  return axios.get(`${API_ENDPOINT}`, { params: request })
}

export const getOperator = (request?: GetOperatorRequest): Promise<GetOperatorResponse> => {
  return axios.get(`${API_ENDPOINT}${request?.id ? `/${request.id}` : ''}`)
}

export const createOperator = (request: CreateOperatorRequest): Promise<CreateOperatorResponse> => {
  return axios.post(API_ENDPOINT, request)
}

export const updateOperator = (request: UpdateOperatorRequest): Promise<UpdateOperatorResponse> => {
  return axios.put(`${API_ENDPOINT}/${request.id}`, request)
}

export const deleteOperator = (request: DeleteOperatorRequest): Promise<DeleteOperatorResponse> => {
  return axios.delete(`${API_ENDPOINT}/${request.id}`)
}
